import { AGENT_URL } from '../config';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

/**
 * Send a message to the MMM Ask Analyst agent.
 * @param {string} message
 * @param {{ region?: string, quarter?: string, activeTab?: string }} context
 * @param {string|null} conversationId
 */
export async function sendAgentMessage(message, context = {}, conversationId = null) {
  const payload = {
    message,
    context: {
      region: context.region || 'GLOBAL',
      quarter: context.quarter || 'Q4FY26',
      activeTab: context.activeTab || null,
    },
    conversation_id: conversationId,
  };

  const response = await fetch(`${AGENT_URL}/api/agent/chat`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error(
      'Ask Analyst could not verify your session. Ensure the agent service uses the same JWT_SECRET_KEY as the backend, then restart the agent.'
    );
  }

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.error || 'Agent request failed');
  }

  const data = await response.json();
  const traceId = response.headers.get('X-Trace-Id');
  return { ...data, trace_id: data.trace_id || traceId };
}

export async function checkAgentHealth() {
  const response = await fetch(`${AGENT_URL}/api/agent/health`, {
    headers: getAuthHeaders(),
  });
  return response.ok;
}
